import React from 'react'
import AboutComp from '../components/About/AboutComp'

const About = () => {
  return (
    <>
        <AboutComp/> 
    </>
  )
}

export default About